<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <template v-if="reserveStatus!=null">
      <template
        v-if="!reserveStatus"
      >
        <not-active-page
          :product-name="$t('ReservationSystem')"
          @click="activeDialog = true"
        />
      </template>
      <template v-else>
        <active-dashboard @edit="editReserveInfo" />
      </template>
    </template>
    <template v-else>
      <v-progress-circular indeterminate />
    </template>

    <v-dialog
      v-model="activeDialog"
      max-width="500px"
      persistent
    >
      <base-form
        :editing-object="reserveStatus"
        :schema="schemas"
        @close="activeDialog=false"
        @submit="saveUserInfo"
      >
        <div>{{ $t('PlannedSettings') }}</div>
        <template #subtitle>
          {{ $t('PlannedSettingsHint') }}
        </template>
      </base-form>
    </v-dialog>
  </div>
</template>

<script>
import GlobalConfig from '@/model/global/GlobalSettings'
import NotActivePage from '@/views/SaaS/widget/NotActivePage.vue'
import {
  editUserInfo,
  getReservationStatus,
  getReservationUserList
} from '@/model/dataLayer/service/reservation/reservation'
import BaseForm from '@/views/widget/INK/BaseForm/BaseForm.vue'
import ActiveDashboard from '@/views/AadenPages/settings/reserveSetting/reserveDashboard/ActiveDashboard.vue'
import { VSwitch } from 'vuetify/lib/components'

export default {
  name: 'OpenReserve',
  components: {
    ActiveDashboard,
    BaseForm,
    NotActivePage
  },
  data: function () {
    return {
      ifEdit: -1,
      reservationInfo: null,
      openUserList: null,
      activeDialog: false,
      reserveStatus: null
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'subDominName',
          name: 'SubdomainLink',
          componentProps: {
            disabled: true,
            rules: [
              v => !!v || this.$t('hostCantEmpty'),
              v => !this.openUserList.find(
                it => it.subDominName !== this.reserveStatus.subDominName && it.subDominName === v) ||
                  this.$t('thisHostnameAlreadyUse')
            ]
          }
        },
        {
          key: 'mapUrl',
          name: 'GoogleMapsLink'
        },
        {
          key: 'autoConfirmReservation',
          hint: 'AutoConfirmReservationHint',
          component: VSwitch
        },
        {
          key: 'allowOnlyOneActiveReservation',
          hint: 'AllowOnlyOneActiveReservationHint',
          component: VSwitch
        },
        {
          key: 'maxReservationPerSlot',
          hint: 'MaxReservationPerSlotHint'
        },
        {
          key: 'reservationTimeLimit',
          hint: 'reservationTimeLimitHint'
        }

      ]
    }

  },
  watch: {
    activeDialog (val) {
      if (!val) {
        this.reload()
      }
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    async saveUserInfo (info) {
      await editUserInfo(info)
      this.activeDialog = false
    },
    editReserveInfo () {
      this.activeDialog = true
    },
    async reload () {
      this.openUserList = await getReservationUserList()
      this.reserveStatus = await getReservationStatus()
      if (this.reserveStatus) {
        this.reservationInfo = this.openUserList.find(it => it.id === parseInt(GlobalConfig.DeviceId))
        this.reservationInfo = {
          ...this.reservationInfo,
          hostName: 'https://' + this.reservationInfo.subDominName + '.reservation.aaden.io'
        }
        this.QRCode = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + this.reservationInfo.hostName
      }
    }
  }
}
</script>

<style scoped>

</style>
